import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {LicenseInfoFormComponent} from './license-info-form.component';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {PortalSelectModule} from '../portal-select/portal-select.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {MatTabsModule} from '@angular/material/tabs';
import {MatIconModule} from '@angular/material/icon';
import {ButtonModule, TableModule} from '@ucx/ui-cmp';
import {InputTrimmerModule} from '../input-trimmer/input-trimmer.module';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatTableModule} from '@angular/material/table';
import {PermissionModule} from '../../../../shared/permission';
import {MatDialogModule} from '@angular/material/dialog';
import {MatSortModule} from '@angular/material/sort';
import {MatButtonModule} from '@angular/material/button';
import {MatSelectModule} from '@angular/material/select';
import {MatNativeDateModule} from '@angular/material/core';
import {PaginatorModule} from '../paginator/paginator.module';
import {MatMenuModule} from '@angular/material/menu';
import {PrintModule} from '../../../../shared/components/print/print.module';
import {ConfirmModalModule} from '../confirm-modal/confirm-modal.module';
import {RounderModule} from '../../../../shared/utils/pipes';
import {PaymentModalModule} from '../../../financial/payment/payment-modal/payment-modal.module';
import {PaymentSuccessModalModule} from '../../../financial/payment/payment-success-modal/payment-success-modal.module';
import {TableExporterModule} from '../../../../shared/components/table-exporter/table-exporter.module';
import {MatTooltipModule} from '@angular/material/tooltip';
import {NgxMatSelectSearchModule} from 'ngx-mat-select-search';
import {FilterModule} from '../../../../shared/components/filter/filter.module';
import {SpinnerButtonModule} from '../spinner-button/spinner-button.module';
import {TooltipModule} from '../tooltip/tooltip.module';
import {MatProgressBarModule} from "@angular/material/progress-bar";
import {NgxDropzoneModule} from "ngx-dropzone";





import {UploadFileListModule} from '../../../../shared/components/upload-file-list/upload-file-list.module';
@NgModule({
  declarations: [ LicenseInfoFormComponent ],
  imports: [
    UploadFileListModule,
    CommonModule,
    MatCheckboxModule,
    MatTableModule,
    PermissionModule,
    MatDialogModule,
    MatSortModule,
    MatButtonModule,
    MatSelectModule,
    MatTabsModule,
    FormsModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    PaginatorModule,
    MatInputModule,
    MatIconModule,
    MatMenuModule,
    PrintModule,
    ConfirmModalModule,
    RounderModule,
    PaymentModalModule,
    MatCheckboxModule,
    PaymentSuccessModalModule,
    TableExporterModule,
    MatTooltipModule,
    NgxMatSelectSearchModule,
    FilterModule,
    SpinnerButtonModule,
    PortalSelectModule,
    ButtonModule,
    TableModule,
    InputTrimmerModule,
    TooltipModule,
    MatProgressBarModule,
    NgxDropzoneModule
  ],
  exports: [
    LicenseInfoFormComponent
  ]
})
export class LicenseInfoFormModule { }
